/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1RecruiterModel } from '../../entities/v1/RecruiterModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1RecruiterModelSchema = z.object({
  id: z.string(),
  name: z.string(),
}) as unknown as ToZod<V1RecruiterModel>